import React from 'react'

export default class Home extends React.Component {
  render() {

    return (
      <div>
        Hello Reduxion!
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ../app/containers/Home.jsx